const ProcurementTenderType = {
  GET_PROCUREMENT_TENDER_LIST: 'GET_PROCUREMENT_TENDER_LIST',
  GET_PROCUREMENT_TENDER_LIST_SUCCESS: 'GET_PROCUREMENT_TENDER_LIST_SUCCESS',
  GET_PROCUREMENT_TENDER_LIST_FAIL: 'GET_PROCUREMENT_TENDER_LIST_FAIL',
  GET_PROCUREMENT_TENDER_LIST_REQUEST_RESET: 'GET_PROCUREMENT_TENDER_LIST_REQUEST_RESET',
  UPDATE_PROCUREMENT_TENDER_INFO_REQUEST: 'UPDATE_PROCUREMENT_TENDER_INFO_REQUEST',

  CHECK_TENDER_NAME_IS_EXISTS: 'CHECK_TENDER_NAME_IS_EXISTS',
  CHECK_TENDER_NAME_IS_EXISTS_SUCCESS: 'CHECK_TENDER_NAME_IS_EXISTS_SUCCESS',
  CHECK_TENDER_NAME_IS_EXISTS_FAIL: 'CHECK_TENDER_NAME_IS_EXISTS_FAIL',

  RESET_ACTIVE_TENDER_ITEM: 'RESET_ACTIVE_TENDER_ITEM',
  SET_ACTIVE_TENDER_ITEM: 'SET_ACTIVE_TENDER_ITEM',

  CREATE_TENDER_COPY: 'CREATE_TENDER_COPY',
  CREATE_TENDER_COPY_SUCCESS: 'CREATE_TENDER_COPY_SUCCESS',
  CREATE_TENDER_COPY_FAIL: 'CREATE_TENDER_COPY_FAIL',
  CREATE_TENDER_COPY_RESET: 'CREATE_TENDER_COPY_RESET',

  UPDATE_TENDER_PROGRESS: 'UPDATE_TENDER_PROGRESS',
  UPDATE_TENDER_SUCCESS: 'UPDATE_TENDER_SUCCESS',
  UPDATE_TENDER_ERROR: 'UPDATE_TENDER_ERROR',

  GET_DOCUMENTS_PROGRESS: 'GET_DOCUMENTS_PROGRESS',
  GET_DOCUMENTS_SUCCESS: 'GET_DOCUMENTS_SUCCESS',
  GET_DOCUMENTS_ERROR: 'GET_DOCUMENTS_ERROR',

  GET_PROCUREMENT_BID_PARAMETER: 'GET_PROCUREMENT_BID_PARAMETER',
  GET_PROCUREMENT_BID_PARAMETER_SUCCESS: ' GET_PROCUREMENT_BID_PARAMETER_SUCCESS',
  GET_PROCUREMENT_BID_PARAMETER_FAIL: 'GET_PROCUREMENT_BID_PARAMETER_FAIL',
  GET_PROCUREMENT_BID_PARAMETER_REQUEST_RESET: 'GET_PROCUREMENT_BID_PARAMETER_REQUEST_RESET',

  ADD_NEW_BID_PARAMETER_ACTION: 'ADD_NEW_BID_PARAMETER_ACTION',

  GET_PROCUREMENT_LANE_INFORMATION: 'GET_PROCUREMENT_LANE_INFORMATION',
  GET_PROCUREMENT_LANE_INFORMATION_SUCCESS: 'GET_PROCUREMENT_LANE_INFORMATION_SUCCESS',
  GET_PROCUREMENT_LANE_INFORMATION_FAIL: 'GET_PROCUREMENT_LANE_INFORMATION_FAIL',
  GET_PROCUREMENT_LANE_INFORMATION_REQUEST_RESET: 'GET_PROCUREMENT_LANE_INFORMATION_REQUEST_RESET',

  GET_PROCUREMENT_ADD_LANE_INFORMATION: 'GET_PROCUREMENT_ADD_LANE_INFORMATION',
  GET_PROCUREMENT_ADD_LANE_INFORMATION_SUCCESS: 'GET_PROCUREMENT_ADD_LANE_INFORMATION_SUCCESS',
  GET_PROCUREMENT_ADD_LANE_INFORMATION_FAIL: 'GET_PROCUREMENT_ADD_LANE_INFORMATION_FAIL',
  GET_PROCUREMENT_ADD_LANE_INFORMATION_REQUEST_RESET: 'GET_PROCUREMENT_ADD_LANE_INFORMATION_REQUEST_RESET',

  GET_TENDER_CARRIER_LIST: 'GET_TENDER_CARRIER_LIST',
  GET_TENDER_CARRIER_LIST_SUCCESS: ' GET_TENDER_CARRIER_LIST_SUCCESS',
  GET_TENDER_CARRIER_LIST_FAIL: ' GET_TENDER_CARRIER_LIST_FAIL',
  GET_TENDER_CARRIER_LIST_REQUEST_RESET: ' GET_TENDER_CARRIER_LIST_REQUEST_RESET',

  GET_PROCUREMENT_HISTORICAL_BID_LIST: 'GET_PROCUREMENT_HISTORICAL_BID_LIST',
  GET_PROCUREMENT_HISTORICAL_BID_LIST_SUCCESS: 'GET_PROCUREMENT_HISTORICAL_BID_LIST_SUCCESS',
  GET_PROCUREMENT_HISTORICAL_BID_LIST_FAIL: 'GET_PROCUREMENT_HISTORICAL_BID_LIST_FAIL',
  GET_PROCUREMENT_HISTORICAL_BID_LIST_REQUEST_RESET: 'GET_PROCUREMENT_HISTORICAL_BID_LIST_REQUEST_RESET',

  GET_PROCUREMENT_ADD_TRANSPORT_PROVIDER: 'GET_PROCUREMENT_ADD_TRANSPORT_PROVIDER',
  GET_PROCUREMENT_ADD_TRANSPORT_PROVIDER_SUCCESS: 'GET_PROCUREMENT_ADD_TRANSPORT_PROVIDER_SUCCESS',
  GET_PROCUREMENT_ADD_TRANSPORT_PROVIDER_FAIL: 'GET_PROCUREMENT_ADD_TRANSPORT_PROVIDER_FAIL',
  GET_PROCUREMENT_ADD_TRANSPORT_PROVIDER_REQUEST_RESET: 'GET_PROCUREMENT_ADD_TRANSPORT_PROVIDER_REQUEST_RESET',

  ADD_NEW_LANE_BUTTON: 'ADD_NEW_LANE_BUTTON',
};

export default ProcurementTenderType;
